var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "DataProtection",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    d: "M6.3,64h33.5c2.2,0,4-1.8,4-4V4c0-2.2-1.8-4-4-4H6.3c-2.2,0-4,1.8-4,4v56C2.3,62.2,4.1,64,6.3,64z",
    className: "color365470 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "M6.2,55.2h33.7c0.6,0,1-0.5,1-1V7.5c0-0.6-0.5-1-1-1H6.2c-0.6,0-1,0.5-1,1v46.7C5.2,54.7,5.7,55.2,6.2,55.2z ",
    className: "colorf4f2f2 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M21.8 62h2.5c.6 0 1.1-.5 1.1-1.1v-2.5c0-.6-.5-1.1-1.1-1.1h-2.5c-.6 0-1.1.5-1.1 1.1v2.5C20.7 61.5 21.2 62 21.8 62zM26.5 2.6H19c-.4 0-.7.3-.7.7s.3.7.7.7h7.5c.4 0 .7-.3.7-.7S26.8 2.6 26.5 2.6zM29.5 2.8c-.2-.2-.5-.3-.7-.1-.1 0-.1.1-.2.1-.1.1-.1.1-.1.2 0 .1-.1.2-.1.3 0 .2.1.3.2.5.1.1.1.1.2.1.1 0 .2.1.3.1.2 0 .3-.1.5-.2.1-.1.2-.3.2-.5C29.7 3.1 29.6 2.9 29.5 2.8z",
    className: "colorffffff svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M37.8,22.6l-0.1-2.3l-2.3-0.2c-5.5-0.4-9.7-3.2-10.8-4.1l-1.5-1.1L21.5,16c-1.2,0.9-5.4,3.7-10.9,4.1 l-2.3,0.2l-0.1,2.3c-0.4,12,4.8,21.4,13.8,25.3l1,0.4l1-0.4c6.7-2.9,11.3-8.8,13-16.6l0.5-2.7C37.8,26.6,37.9,24.6,37.8,22.6z",
    className: "colord82b5d svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M35.5,22.6l0-0.2l-0.2,0c-6.1-0.4-10.8-3.6-12.1-4.6l-0.1-0.1l-0.2,0.1c-1.3,1-6,4.1-12.1,4.6l-0.2,0l0,0.2 c-0.2,5.3,0.7,18.1,12.4,23.1l0.1,0l0.1,0c7.2-3.1,10.3-9.1,11.5-14.5l0.5-2.7C35.6,26.2,35.6,24.1,35.5,22.6z",
    className: "colorffffff svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f9f9f",
    d: "M53.9,21.9c-3.9,0-7.1,2.9-7.7,6.6h-3.4h-2.9H22.1v2.7h2V35h2.3v-3.8h2.4v2.7h2.3v-2.7h9h2.9h3.4 c0.7,3.6,3.9,6.3,7.7,6.3c4.3,0,7.8-3.5,7.8-7.8C61.7,25.4,58.2,21.9,53.9,21.9z M56.1,34.5V25c1.8,0.8,3.1,2.6,3.1,4.8 C59.2,31.8,57.9,33.6,56.1,34.5z",
    className: "color7ca3c2 svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 0.7,
    x: 22.1,
    y: 30.5,
    fill: "#919191",
    className: "color6c99b7 svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 0.7,
    x: 24,
    y: 34.3,
    fill: "#919191",
    className: "color6c99b7 svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 0.7,
    x: 26.3,
    y: 30.5,
    fill: "#919191",
    className: "color6c99b7 svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 0.7,
    x: 28.7,
    y: 33.2,
    fill: "#919191",
    className: "color6c99b7 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M61.7,29.7c0,4.3-3.5,7.8-7.8,7.8c-3.8,0-7-2.7-7.7-6.3H30.9v-0.7h15.3c0.7,3.6,3.9,6.3,7.7,6.3 c4.2,0,7.6-3.3,7.8-7.4C61.7,29.5,61.7,29.6,61.7,29.7z",
    className: "color6c99b7 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2e2",
    d: "M22.1,37.7c-0.3,0-0.6-0.3-0.6-0.6V25c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v12.1 C22.7,37.4,22.4,37.7,22.1,37.7z",
    className: "colore2e2e2 svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.aa1a73def7e03a497e1e38ac51d58c22.svg";
export { ForwardRef as ReactComponent };